var map = {
	"./R__Migrate_graph_to_branch.coffee": 2056,
	"./U0__Remove_SizeParams.coffee": 2057,
	"./U1__Remove_Colors.coffee": 2058,
	"./V0__Bootstrap.coffee": 2059,
	"./V1_10__Add_GraphConfig.coffee": 2060,
	"./V1_1__Add_merge_request.coffee": 2077,
	"./V1_2__Migrate_old_services.coffee": 2078,
	"./V1_3__Migrate_importExcel_to_import.coffee": 2079,
	"./V1_4__Migrate_upload_transformations_file.coffee": 2080,
	"./V1_5__Migrate_AppView_to_GraphView.coffee": 2081,
	"./V1_6__Protect_config_branch_by_default.coffee": 2082,
	"./V1_7__Add_NodeSizeParams.coffee": 2083,
	"./V1_8__Add_RelationSizeParams.coffee": 2084,
	"./V1_9__Add_IdFormat.coffee": 2085,
	"./V1__Bootstrap.coffee": 2086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2055;